import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";

const CheckoutForm = forwardRef(
  (
    {
      cartItems,
      address,
      purchaseCompleted,
      email,
      setIsLoading,
      isSubscription,
    },
    ref
  ) => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    // const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
      console.log("submitting");

      // e.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
      }

      setIsLoading(true);
      var error;
      if (isSubscription) {
        sessionStorage.setItem("name", address.name);
        error = await stripe.confirmPayment({
          elements,
          confirmParams: {
            // Make sure to change this to your payment completion page

            return_url: `https://tailoredstories.web.app/order-confirmation-zine`,
            // return_url: `http://localhost:3000/order-confirmation-zine`,
          },
        })["error"];
      } else {
        sessionStorage.setItem("cartItems", JSON.stringify(cartItems));
        sessionStorage.setItem("name", address.name);
        error = await stripe.confirmPayment({
          elements,
          confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: `https://tailoredstories.web.app/order-confirmation`,
            // return_url: `http://localhost:3000/order-confirmation`,
          },
        })["error"];
      }

      // This point will only be reached if there is an immediate error when
      // confirming the payment. Otherwise, your customer will be redirected to
      // your `return_url`. For some payment methods like iDEAL, your customer will
      // be redirected to an intermediate site first to authorize the payment, then
      // redirected to the `return_url`.
      // if (error.type === "card_error" || error.type === "validation_error") {
      //   setMessage(error.message);
      // } else {
      //   setMessage("An unexpected error occurred.");
      // }

      // setIsLoading(false);
      if (error) {
        console.error("Error confirming payment:", error);
        if (error.type === "card_error" || error.type === "validation_error") {
          setMessage(error.message);
        } else {
          setMessage("An unexpected error occurred.");
        }
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch(`${API_BASE_URL}/submit-order`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customerEmail: email,
            address: address,
            items: cartItems,
          }),
        });

        if (response.ok) {
          console.log("Order Submitted");
        } else {
          alert("Failed to submit the form.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("An error occurred. Please try again.");
      }
      setIsLoading(false);
    };

    useImperativeHandle(ref, () => ({
      handleSubmit,
    }));

    const paymentElementOptions = {
      layout: "accordion",
    };

    return (
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" options={paymentElementOptions} />
        {/* <button disabled={isLoading || !stripe || !elements} id="submit">
          <span id="button-text">
            {isLoading ? (
              <div className="spinner" id="spinner"></div>
            ) : (
              "Pay now"
            )}
          </span>
        </button> */}
        {/* Show any error or success messages */}
        {/* {message && <div id="payment-message">{message}</div>} */}
      </form>
    );
  }
);

export default CheckoutForm;
